<template>
  <v-container fluid>
    <v-layout row>
      <v-flex>
        <v-card>
          <v-card-title primary-title class="primary white--text headline">
            Datasets
            <v-spacer></v-spacer>
            <v-btn medium depressed flat icon color="white" to="datasets/add" v-if="$auth.user().AuthScope.includes('dataset:manage')" >
              <v-icon medium>add_circle_outline</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="filteredHeaders"
            :items="items"
            hide-actions
            :loading="datasetListLoading">
              <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td>{{ props.item.id }}</td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.language.name }}</td>
                <td>
                  <v-chip
                  class="white--text"
                  small
                  v-for="(dataSource, i) in props.item.dataSources" :key="i"
                  :color="dataSource.color">
                    {{ dataSource.name }}
                  </v-chip>

                </td>
                <td>{{ props.item.createdDate | formatDate }}</td>
                <td>{{props.item.status}}</td>
                <td>{{props.item.count}}</td>
                <td class="text-xs-right" v-if="$auth.user().AuthScope.includes('dataset:manage')">
                  <v-tooltip bottom color="accent">
                    <v-icon
                      class="mr-2"
                      color="accent"
                      slot="activator"
                      @click="$router.push(`/datasets/${props.item.id}/edit`)"
                    >
                      edit
                    </v-icon>
                    <span>Edit Item</span>
                  </v-tooltip>
                  <v-tooltip bottom color="error">
                    <v-icon
                      color="error"
                      slot="activator"
                      @click="dialog = true; itemToDelete = props.item;"
                    >
                      delete
                    </v-icon>
                    <span>Delete Item</span>
                  </v-tooltip>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
          v-model="dialog"
          max-width="500"
          v-if="$auth.user().AuthScope.includes('dataset:manage')"
        >
          <v-card>
            <v-card-title class="headline">Delete dataset</v-card-title>
            <v-card-text>
              Are you sure to delete this dataset? You will lose the access to this dataset!
            </v-card-text>
            <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
              <v-spacer></v-spacer>
              <v-btn
                color="grey darken-1"
                flat
                depressed
                :disabled="deleteLoading"
                @click="dialog = false; itemToDelete = {};"
              >
                Cancel
              </v-btn>
              <v-btn
                color="error"
                depressed
                class="white--text"
                :loading="deleteLoading"
                :disabled="deleteLoading"
                @click.native="deleteItem()"
              >
                Delete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      headers: [
        {text: 'ID', sortable: true, value: 'id'},
        {text: 'Name', sortable: true, value: 'name'},
        {text: 'Language', sortable: false, value: 'language'},
        {text: 'Data Source(s)', sortable: false, value: 'dataSources'},
        {text: 'Created Date', sortable: true, value: 'createdDate'},
        {text: 'Status', sortable: true, value: 'status'},
        {text: 'Number of Instances', sortable: true, value: 'count'},
        {text: 'Actions', value: 'name', sortable: false, align: 'right'}
      ],
      items: [],
      dialog: false,
      itemToDelete: {},
      deleteLoading: false,
      datasetListLoading: false,
      pagination: {
        sortBy: 'id'
      }
    }
  },
  computed: {
    filteredHeaders () {
      if (!this.$auth.user().AuthScope.includes('dataset:manage')) {
        return this.headers.slice(0, 4)
      }
      return this.headers
    }
  },
  created () {
    this.datasetListLoading = true
    this.fetchDatasets()
  },
  methods: {
    fetchDatasets () {
      this.axios.get('/datasets')
        .then(response => {
          response.data.forEach(dataset => {
            let dataSources = []
            if (dataset.solr_core_names) {
              dataSources = dataset.solr_core_names.map((i) => { return {color: 'accent', name: i} })
            }
            this.items.push({
              id: dataset.id,
              createdDate: new Date(dataset.created_date),
              filePath: dataset.file_path,
              language: dataset.language,
              name: dataset.name,
              solrCoreNames: dataset.solr_core_names,
              dataSources: dataSources,
              editLink: `/datasets/${dataset.id}/edit`,
              status: dataset.status,
              count: dataset.count
            })
          })
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.datasetListLoading = false
        })
    },
    deleteItem () {
      this.deleteLoading = true
      console.log(this.itemToDelete)
      this.axios.delete(`/datasets/${this.itemToDelete.id}`)
        .then(response => {
          let index = this.items.indexOf(this.itemToDelete)
          console.log(index)
          this.items.splice(index, 1)
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.deleteLoading = false
          this.dialog = false
          this.itemToDelete = {}
        })
    }
  }
}
</script>

<style>

</style>
